import { initialState } from '../initial_state';

export function isDevelopment() {
  if (typeof process !== 'undefined')
    return process.env.NODE_ENV === 'development';
  else return import.meta.env.DEV;
}

export function isProduction() {
  if (typeof process !== 'undefined')
    return process.env.NODE_ENV === 'production';
  else return import.meta.env.PROD;
}

// 'collections' is a Mastodon 4.6 feature. Regular Mastodon does not advertise
// it in `features`; the standalone initial_state generator adds it when the
// connected instance reports api_versions.mastodon >= 10, so it is only used to
// gate UI in standalone mode (see navigation_panel).
export type ServerFeatures = 'fasp' | 'collections';

export function isServerFeatureEnabled(feature: ServerFeatures) {
  return initialState?.features.includes(feature) ?? false;
}

type ClientFeatures = 'redesign' | 'redesign-status';

const buildClientFeatures: readonly ClientFeatures[] =
  import.meta.env.VITE_EXPERIMENTAL_UI === 'true' ? ['redesign'] : [];

export function isClientFeatureEnabled(feature: ClientFeatures) {
  if (buildClientFeatures.includes(feature)) {
    return true;
  }

  try {
    const features =
      window.localStorage.getItem('experiments')?.split(',') ?? [];
    return features.includes(feature);
  } catch (err) {
    console.warn('Could not access localStorage to get client features', err);
    return false;
  }
}

/* Checks if the 5.0 redesign features are enabled or not. */
export function isRedesignEnabled() {
  return isClientFeatureEnabled('redesign');
}

export function isRedesignStatusEnabled() {
  return isRedesignEnabled() && isClientFeatureEnabled('redesign-status');
}
